import { FC } from "react";

import List from "apps/website/components/base/List/List";
import {
  ListColumns,
  AvailableTag,
  BreakpointListColumns,
} from "apps/website/components/base/List/List.map";

import CondensedListItem, {
  ICondensedListItemProps,
} from "./CondensedListItem/CondensedListItem";
import { ImageSize } from "./CondensedListItem/CondensedListItem.map";
import {
  condensedListStyleClassMap,
  TCondensedListStyle,
} from "./CondensedList.map";

export interface ICondensedListProps {
  items: ICondensedListItemProps[];
  columns?: ListColumns | BreakpointListColumns;
  listType?: AvailableTag
  imageSize?: ImageSize;
  style?: TCondensedListStyle;
}

const CondensedList: FC<ICondensedListProps> = ({ items, listType = "ul", columns = "default", imageSize, style = "default" }) => (
  <List component={CondensedList.name} tag={listType} columns={columns} className={`space-y-4 ${condensedListStyleClassMap[style]}`}>
    { items.map((item, index) => (
      <CondensedListItem key={`condensed-list-item-${index}`} imageSize={imageSize} {...item} title={listType === "ol" ? `${index + 1}. ${item.title}` : item.title}/>
    )) }
  </List>
);

export default CondensedList;
